export const OMSDBOrderSummaryTableData = [
  {
    th1: "Order Id",
    th2: "Customer",
    th3: "Item",
    th4: "Order Date",
    th5: "Delivery Date",
    th6: "Amount",
    th7: "Order Status",
    th8: "Payment Method",
  },
  {
    td1: "KCVF112L",
    td2: "MOHIT GOPAL",
    td3: `Nike Men's Air Zoom Pegasus 36 Running Shoes (1)`,
    td4: "12th May",
    td5: "12th May",
    td6: "9995",
    td7: "Delivered",
    td8: "Bank Transfer",
  },
  {
    td1: "KCVF112L",
    td2: "MOHIT GOPAL",
    td3: `Nike Men's Air Zoom Pegasus 36 Running Shoes (1)`,
    td4: "12th May",
    td5: "12th May",
    td6: "9995",
    td7: "Delivered",
    td8: "Bank Transfer",
  },
  {
    td1: "KCVF112L",
    td2: "MOHIT GOPAL",
    td3: `Nike Men's Air Zoom Pegasus 36 Running Shoes (1)`,
    td4: "12th May",
    td5: "12th May",
    td6: "9995",
    td7: "Delivered",
    td8: "Bank Transfer",
  },
  {
    td1: "KCVF112L",
    td2: "MOHIT GOPAL",
    td3: `Nike Men's Air Zoom Pegasus 36 Running Shoes (1)`,
    td4: "12th May",
    td5: "12th May",
    td6: "9995",
    td7: "Delivered",
    td8: "Bank Transfer",
  },
  {
    td1: "KCVF112L",
    td2: "MOHIT GOPAL",
    td3: `Nike Men's Air Zoom Pegasus 36 Running Shoes (1)`,
    td4: "12th May",
    td5: "12th May",
    td6: "9995",
    td7: "Delivered",
    td8: "Bank Transfer",
  },
  {
    td1: "KCVF112L",
    td2: "MOHIT GOPAL",
    td3: `Nike Men's Air Zoom Pegasus 36 Running Shoes (1)`,
    td4: "12th May",
    td5: "12th May",
    td6: "9995",
    td7: "Delivered",
    td8: "Bank Transfer",
  },
  {
    td1: "KCVF112L",
    td2: "MOHIT GOPAL",
    td3: `Nike Men's Air Zoom Pegasus 36 Running Shoes (1)`,
    td4: "12th May",
    td5: "12th May",
    td6: "9995",
    td7: "Delivered",
    td8: "Bank Transfer",
  },
];
export const OMSDBMarketPlaceTableData = [
  {
    th1: "Brand Id",
    th2: "Brand Name",
    th3: "Category",
    th4: "Sub Category",
    th5: "Item",
    th6: "Quantity",
    th7: "Products Add On",
    th8: "Details",
  },
  {
    td1: "123456AK",
    td2: "Samsung",
    td3: `Electronics`,
    td4: "Mobile Phones",
    td5: "Samsung Galaxy s22 ultra",
    td6: "2",
    td7: "01-01-2022",
    td8: `${(<b>Get Details</b>)}`,
  },
  {
    td1: "123456AK",
    td2: "Samsung",
    td3: `Electronics`,
    td4: "Mobile Phones",
    td5: "Samsung Galaxy s22 ultra",
    td6: "2",
    td7: "01-01-2022",
    td8: `${(<b>Get Details</b>)}`,
  },
  {
    td1: "123456AK",
    td2: "Samsung",
    td3: `Electronics`,
    td4: "Mobile Phones",
    td5: "Samsung Galaxy s22 ultra",
    td6: "2",
    td7: "01-01-2022",
    td8: `${(<b>Get Details</b>)}`,
  },
  {
    td1: "123456AK",
    td2: "Samsung",
    td3: `Electronics`,
    td4: "Mobile Phones",
    td5: "Samsung Galaxy s22 ultra",
    td6: "2",
    td7: "01-01-2022",
    td8: `${(<b>Get Details</b>)}`,
  },
  {
    td1: "123456AK",
    td2: "Samsung",
    td3: `Electronics`,
    td4: "Mobile Phones",
    td5: "Samsung Galaxy s22 ultra",
    td6: "2",
    td7: "01-01-2022",
    td8: `${(<b>Get Details</b>)}`,
  },
  {
    td1: "123456AK",
    td2: "Samsung",
    td3: `Electronics`,
    td4: "Mobile Phones",
    td5: "Samsung Galaxy s22 ultra",
    td6: "2",
    td7: "01-01-2022",
    td8: `${(<b>Get Details</b>)}`,
  },
  {
    td1: "123456AK",
    td2: "Samsung",
    td3: `Electronics`,
    td4: "Mobile Phones",
    td5: "Samsung Galaxy s22 ultra",
    td6: "2",
    td7: "01-01-2022",
    td8: `${(<b>Get Details</b>)}`,
  },
];
export const INVENTORYDBSupplierTableData = [
  {
    th1: "Supplier Id",
    th2: "Brand Name",
    th3: "Category",
    th4: "Sub Category",
    th5: "Worth",
    th6: "Quantity",
    th7: "Last Deal",
    th8: "Location",
    th9: "Details",
  },
  {
    td1: "KCVF112L",
    td2: "Samsung",
    td3: `Electronics`,
    td4: "Mobile Phones",
    td5: "10,20,000",
    td6: "2",
    td7: "01-01-2022",
    td8: "Delhi",
    td9: "View Details",
  },
  {
    td1: "KCVF112L",
    td2: "Samsung",
    td3: `Electronics`,
    td4: "Mobile Phones",
    td5: "10,20,000",
    td6: "2",
    td7: "01-01-2022",
    td8: "Delhi",
    td9: "View Details",
  },
  {
    td1: "KCVF112L",
    td2: "Samsung",
    td3: `Electronics`,
    td4: "Mobile Phones",
    td5: "10,20,000",
    td6: "2",
    td7: "01-01-2022",
    td8: "Delhi",
    td9: "View Details",
  },
  {
    td1: "KCVF112L",
    td2: "Samsung",
    td3: `Electronics`,
    td4: "Mobile Phones",
    td5: "10,20,000",
    td6: "2",
    td7: "01-01-2022",
    td8: "Delhi",
    td9: "View Details",
  },
  {
    td1: "KCVF112L",
    td2: "Samsung",
    td3: `Electronics`,
    td4: "Mobile Phones",
    td5: "10,20,000",
    td6: "2",
    td7: "01-01-2022",
    td8: "Delhi",
    td9: "View Details",
  },
  {
    td1: "KCVF112L",
    td2: "Samsung",
    td3: `Electronics`,
    td4: "Mobile Phones",
    td5: "10,20,000",
    td6: "2",
    td7: "01-01-2022",
    td8: "Delhi",
    td9: "View Details",
  },
  {
    td1: "KCVF112L",
    td2: "Samsung",
    td3: `Electronics`,
    td4: "Mobile Phones",
    td5: "10,20,000",
    td6: "2",
    td7: "01-01-2022",
    td8: "Delhi",
    td9: "View Details",
  },
];
export const INVENTORYDBInOutTableData = [
  {
    th1: "Product Id",
    th2: "Category",
    th3: "Item",
    th4: "Added on",
    th5: "Amount",
    th6: "Order Status",
    th7: "Quantity",
    th8: "Details",
  },
  {
    td1: "KCVF112L",
    td2: "Electronics",
    td3: `Nike men's air zoon shoes`,
    td4: "12-07-2022",
    td5: "9995",
    td6: "In-Stock",
    td7: "10",
    td8: "View Details",
  },
  {
    td1: "KCVF112L",
    td2: "Electronics",
    td3: `Nike men's air zoon shoes`,
    td4: "12-07-2022",
    td5: "9995",
    td6: "In-Stock",
    td7: "10",
    td8: "View Details",
  },
  {
    td1: "KCVF112L",
    td2: "Electronics",
    td3: `Nike men's air zoon shoes`,
    td4: "12-07-2022",
    td5: "9995",
    td6: "In-Stock",
    td7: "10",
    td8: "View Details",
  },
  {
    td1: "KCVF112L",
    td2: "Electronics",
    td3: `Nike men's air zoon shoes`,
    td4: "12-07-2022",
    td5: "9995",
    td6: "In-Stock",
    td7: "10",
    td8: "View Details",
  },
  {
    td1: "KCVF112L",
    td2: "Electronics",
    td3: `Nike men's air zoon shoes`,
    td4: "12-07-2022",
    td5: "9995",
    td6: "In-Stock",
    td7: "10",
    td8: "View Details",
  },
  {
    td1: "KCVF112L",
    td2: "Electronics",
    td3: `Nike men's air zoon shoes`,
    td4: "12-07-2022",
    td5: "9995",
    td6: "In-Stock",
    td7: "10",
    td8: "View Details",
  },
  {
    td1: "KCVF112L",
    td2: "Electronics",
    td3: `Nike men's air zoon shoes`,
    td4: "12-07-2022",
    td5: "9995",
    td6: "In-Stock",
    td7: "10",
    td8: "View Details",
  },
];
export const FINANCETRANSACTIONSTABLE = [
  {
    td1: "INV-3066",
    td2: "Bedanta Baruah",
    td3: `Bedanta Baruah`,
    td4: "Paid",
    td5: "1799",
    td6: "01.01.2022",
    td7: "10:20:55",
    td8: "UPI",
    td9: "VIEW DETAILS",
  },
  {
    td1: "INV-7865",
    td2: "Mohit Gopal",
    td3: `Mohit Gopal`,
    td4: "Unpaid",
    td5: "7999",
    td6: "01.01.2022",
    td7: "10:20:55",
    td8: "Net Banking",
    td9: "VIEW DETAILS",
  },
  {
    td1: "INV-9874",
    td2: "Bedanta Baruah",
    td3: `Bedanta Baruah`,
    td4: "Overdue",
    td5: "1799",
    td6: "01.01.2022",
    td7: "10:20:55",
    td8: "Debit Card",
    td9: "VIEW DETAILS",
  },
  {
    td1: "INV-7531",
    td2: "Mohit Gopal",
    td3: `Mohit Gopal`,
    td4: "Unpaid",
    td5: "1799",
    td6: "01.01.2022",
    td7: "10:20:55",
    td8: "Credit Card",
    td9: "VIEW DETAILS",
  },
  {
    td1: "INV-8546",
    td2: "Bedanta Baruah",
    td3: `Bedanta Baruah`,
    td4: "Paid",
    td5: "1500",
    td6: "01.01.2022",
    td7: "10:20:55",
    td8: "Net Banking",
    td9: "VIEW DETAILS",
  },
  {
    td1: "INV-3579",
    td2: "Mohit Gopal",
    td3: `Mohit Gopal`,
    td4: "Unpaid",
    td5: "1499",
    td6: "01.01.2022",
    td7: "10:20:55",
    td8: "Cash On Delivery",
    td9: "VIEW DETAILS",
  },
  {
    td1: "INV-9516",
    td2: "Bedanta Baruah",
    td3: `Bedanta Baruah`,
    td4: "Overdue",
    td5: "1399",
    td6: "01.01.2022",
    td7: "10:20:55",
    td8: "Cash On Delivery",
    td9: "VIEW DETAILS",
  },
]
